import { CheckIcon } from "@heroicons/react/outline";

function ESignatureLabel() {
  return (
    <div className="flex items-center gap-1.5 ml-auto text-xs text-gray-600 bg-gray-50 font-semibold font-gilroy border-2 rounded py-1 px-2">
      eSignatures <CheckIcon className="h-4 w-4 text-green" />
    </div>
  );
}

export default ESignatureLabel;
